import HealthCare from "./HealthCare"
import './App.css';

function App() {

  return (
    <div className="App">
      <HealthCare/>
    </div>
  );
}

export default App;
